import { MapPin, CreditCard, Mail } from "lucide-react";

const steps = [
  {
    icon: MapPin,
    title: "Choose your city",
    description: "Any city in the world. Paris, Tokyo, Marrakech—wherever your curiosity leads.",
  },
  {
    icon: CreditCard,
    title: "Pay $1.99",
    description: "One letter, one price. No subscriptions, no hidden fees, no pressure.",
  },
  {
    icon: Mail,
    title: "Receive your letter",
    description: "Within 10 minutes, Eunice's letter arrives in your inbox. Read it, save it, return to it.",
  },
];

const HowItWorks = () => {
  return (
    <section className="py-16 md:py-24 bg-background" aria-labelledby="how-it-works-heading">
      <div className="container max-w-5xl mx-auto px-6">
        {/* Header */}
        <header className="text-center mb-10 md:mb-16">
          <p className="text-xs md:text-sm uppercase tracking-[0.2em] text-muted-foreground mb-2 md:mb-3 font-sans">
            How It Works
          </p>
          <h2 id="how-it-works-heading" className="font-serif text-3xl md:text-4xl text-foreground mb-3 md:mb-4">
            Simple as a postcard
          </h2>
          <p className="text-muted-foreground text-base md:text-lg">
            Three steps from request to reading
          </p>
        </header>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          {steps.map((step, index) => (
            <div key={index} className="text-center">
              {/* Icon */}
              <div className="inline-flex items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-full border-2 border-primary/30 mb-4 md:mb-6">
                <step.icon className="w-5 h-5 md:w-6 md:h-6 text-primary" strokeWidth={1.5} />
              </div>

              {/* Title */}
              <h3 className="font-serif text-lg md:text-xl text-foreground mb-2 md:mb-3">
                {step.title}
              </h3>

              {/* Description */}
              <p className="text-muted-foreground text-base leading-relaxed max-w-xs mx-auto">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
